import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { Alert, Col, Grid, Row } from 'react-bootstrap'

import SideBar from '../SideBar'
import TopBar from '../TopBar'
import NavBar from '../NavBar'
import HitList from '../HitList'
import ToggleAll from '../../components/ToggleAll'
import NewHitlistButton from '../../components/NewHitlistButton'

import styled from 'styled-components'

const StyledNewHitlistButton = styled(NewHitlistButton)`
  margin-left: 10px;
`

const PaddedRow = styled(Row)`
  margin-top: 20px;
`

@observer
class App extends Component {
  constructor(props) {
    super(props)

    this.onDeselect = this.onDeselect.bind(this)
    this.onSelect = this.onSelect.bind(this)
  }

  onDeselect() {
    this.props.store.deSelectAllFiltered()
  }

  onSelect() {
    this.props.store.selectAllFiltered()
  }

  renderResults() {
    const { store } = this.props
    const navBar = <NavBar store={store} />
    const { selectedMode, filteredSelectedIds } = store

    return (
      <Col sm={9} xs={12}>
        {/** Navbar, and results panel **/}
        <PaddedRow>
          <Col sm={4}>
            <div className="pull-left">
              <ToggleAll
                mode={selectedMode}
                onSelect={this.onSelect}
                onDeSelect={this.onDeselect}>
                {filteredSelectedIds.length} selected
              </ToggleAll>
            </div>
            <StyledNewHitlistButton ids={filteredSelectedIds} />
          </Col>
          <Col sm={8}>{navBar}</Col>
        </PaddedRow>
        <Row>
          <Col sm={12}>
            <HitList store={store} />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>{navBar}</Col>
        </Row>
      </Col>
    )
  }

  renderNoResult() {
    return (
      <Col sm={9} xs={12}>
        <Alert bsStyle="danger">
          <h3>
            <b>No results to display!</b>
          </h3>
          <div>
            Try removing some filters or searching for a different term.
          </div>
        </Alert>
      </Col>
    )
  }

  render() {
    const { store } = this.props

    return (
      <Grid fluid>
        <Row>
          <Col sm={12}>
            <TopBar
              store={store}
              dataClassLabels={this.props.dataClassLabels}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={3} xs={12}>
            {/** Side bar for filters, etc. **/}
            <SideBar store={store} />
          </Col>
          {store.itemStore.totalSize > 0 && this.renderResults()}
          {store.itemStore.totalSize === 0 && this.renderNoResult()}
        </Row>
      </Grid>
    )
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired,
}

export default App
